import React, { lazy } from 'react';
import Loadable from 'components/loading/Loadable';
import { CommunityBoardApi } from 'api/community/CommunityBoardApi';
import { InfoProvider } from './context';

const List = Loadable(lazy(() => import('./list')));
const Create = Loadable(lazy(() => import('./create')));
const Edit = Loadable(lazy(() => import('./edit')));

const InfoBoardConfig = {
    routes: [
        {
            path: 'info',
            children: [
                {
                    path: '',
                    element: <InfoProvider><List /></InfoProvider>
                },
                {
                    path: 'create',
                    element: <InfoProvider><Create /></InfoProvider>
                },
                {
                    path: 'modify/:code',
                    element: <InfoProvider><Edit /></InfoProvider>
                }
            ]
        }
    ],
    API: CommunityBoardApi
};

export default InfoBoardConfig;
